export default "__VITE_ASSET__DfqlfEYD__"